import * as Yup from 'yup';
import { phoneNumberFormatter } from './phoneNumber.validation';

// LODGE ENQUIRY SCHEMA
export const LodgeEnquirySetp1Schema = Yup.object().shape({
  userReference: Yup.string()
    .required('User reference is required')
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters'),
  digStartAt: Yup.string().required('Job start date is required'),
  digEndAt: Yup.string().required('Job end date is required'),
  notes: Yup.string().max(500, 'Maximum 500 Characters'),
  addressLine1: Yup.string().required('Address is required')
});

export const LodgeEnquirySetp2Schema = Yup.object().shape({
  activityTypes: Yup.string().required('Activity type is required'),
  enquiryType: Yup.string().required('Enquiry type is required'),
  locationTypes: Yup.array().required('Workplace location(s) is required'),
  authorityId: Yup.string().nullable().required('Working on behalf is required')
});

export const LodgeEnquiryForm1Schema = Yup.object().shape({
  addressLine1: Yup.string().required('Address is required'),
  locationTypes: Yup.array().required('Workplace location(s) is required')
});
export const LodgeEnquiryForm2Schema = Yup.object().shape({
  digStartAt: Yup.string().required('Job start date is required'),
  digEndAt: Yup.string().required('Job end date is required'),
  enquiryType: Yup.string().required('Enquiry type is required')
});

export const LodgeEnquiryForm3Schema = Yup.object().shape({
  userReference: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(50, 'Maximum 50 Characters'),
  notes: Yup.string().max(500, 'Maximum 500 Characters'),
  otherAuthorityName: Yup.string().max(100, 'Maximum 100 Characters'),
  authorityId: Yup.string().nullable().required('Working on behalf is required')
});

const lodgeEnquiryForm4AddressFields = {
  addressLine1: Yup.string().required('Address is required'),
  locality: Yup.string().required('Suburb/Town/City is required'),
  state: Yup.string().required('State is required'),
  postcode: Yup.string()
    .required('Postcode is required')
    .matches(/^\d*$/, 'Numeric characters only')
    .min(4, 'Postcode are 4 characters')
    .max(4, 'Postcode are 4 characters'),
  companyName: Yup.string().max(100, 'Maximum 100 Characters.')
};

/**
 * Step 4 schema for lodge enquiry "One more thing" profile capture.
 *
 * Phone is only validated when the user must enter one (no phone on profile yet).
 * AD-verified numbers are stored as-is and must not block submit when the field is hidden.
 */
export const getLodgeEnquiryForm4Schema = (needPhoneNumber: boolean) =>
  Yup.object().shape({
    ...lodgeEnquiryForm4AddressFields,
    phoneNumber: needPhoneNumber
      ? Yup.string()
          .label('Phone number')
          .max(16, 'Maximum 16 Characters.')
          .required()
          .test(
            'validate-cpnumber',
            'Please enter valid phone number',
            (value: any): any => {
              return phoneNumberFormatter({
                phoneNumber: value || ''
              }).isValid();
            }
          )
      : Yup.string().notRequired()
  });

/** @deprecated Use getLodgeEnquiryForm4Schema(needPhoneNumber) */
export const LodgeEnquiryForm4Schema = getLodgeEnquiryForm4Schema(true);
